import visual from 'assets/images/community/visual.png';

export const krArchive = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `자료실`,
  subjectDesc: `Archive`,
  visual,
  downloadLabel: `다운로드`,
};

export const enArchive = {
  title: `커뮤니티_en`,
  subTitle: `Community`,
  subject: `자료실`,
  subjectDesc: `Archive`,
  visual,
  downloadLabel: ``,
};
